import { supabase } from '../lib/supabase';

export const applicationLogService = {
  async getLogs(filters = {}) {
    let query = supabase?.from('application_logs')?.select(`
        *,
        user_profiles!inner(full_name, email),
        companies!inner(name)
      `)?.order('created_at', { ascending: false });

    // Filter by date range (past two years by default)
    const twoYearsAgo = new Date();
    twoYearsAgo?.setFullYear(twoYearsAgo?.getFullYear() - 2);
    
    if (filters?.startDate) {
      query = query?.gte('created_at', filters?.startDate);
    } else {
      query = query?.gte('created_at', twoYearsAgo?.toISOString());
    }

    if (filters?.endDate) {
      query = query?.lte('created_at', filters?.endDate);
    }

    if (filters?.level) {
      query = query?.eq('level', filters?.level);
    }

    if (filters?.category) {
      query = query?.eq('category', filters?.category);
    }

    if (filters?.search) {
      query = query?.or(`description.ilike.%${filters?.search}%,action.ilike.%${filters?.search}%`);
    }

    if (filters?.limit) {
      query = query?.limit(filters?.limit);
    } else {
      query = query?.limit(100);
    }

    const { data, error } = await query;

    if (error) throw error;

    return data?.map(log => ({
      id: log?.id,
      level: log?.level,
      action: log?.action,
      category: log?.category,
      description: log?.description,
      metadata: log?.metadata,
      ipAddress: log?.ip_address,
      userAgent: log?.user_agent,
      resourceId: log?.resource_id,
      resourceType: log?.resource_type,
      createdAt: log?.created_at,
      userFullName: log?.user_profiles?.full_name,
      userEmail: log?.user_profiles?.email,
      companyName: log?.companies?.name
    }));
  },

  async getLogCategories() {
    const { data, error } = await supabase?.from('application_logs')?.select('category');

    if (error) throw error;

    // Use JavaScript Set to get distinct categories on client side
    const distinctCategories = [...new Set(data?.map(item => item?.category)?.filter(Boolean))];
    return distinctCategories;
  },

  async getLogLevels() {
    return ['info', 'warning', 'error', 'critical'];
  }
};